import { useEffect, useState } from "react";

const COOKIE_CONSENT_KEY = "cookieConsentGiven";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.wrapper}>
      <p style={styles.text}>
        На сайте собираются файлы cookie и данные о поведении на сайте, нужные нам для аналитики, в соответствии с{" "}
        <a
          href="https://privacy.medtouch.org"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          Политикой
        </a>. Если Вы согласны, нажмите «Согласен». Запретить обработку cookie Вы можете в настройках Вашего браузера.
      </p>
      <button onClick={handleAccept} style={styles.button}>
        Согласен
      </button>
    </div>
  );
};

// Адаптивные стили
const styles = {
  wrapper: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: "#111",
    color: "#fff",
    padding: "16px 20px",
    textAlign: "center",
    zIndex: 9999,
    boxSizing: "border-box",
    fontSize: "16px",
  },
  text: {
    marginBottom: 10,
    lineHeight: 1.5,
  },
  link: {
    textDecoration: "underline",
    color: "#fff",
  },
  button: {
    backgroundColor: "#fff",
    color: "#111",
    padding: "8px 16px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
};

// Мобильные стили через media query
const applyResponsiveStyles = () => {
  if (typeof window !== "undefined") {
    const isMobile = window.innerWidth < 600;
    if (isMobile) {
      styles.wrapper.padding = "12px 16px";
      styles.wrapper.fontSize = "14px";
      styles.button.fontSize = "13px";
    }
  }
};

applyResponsiveStyles();

export default CookieConsent;
